import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import dayjs from "dayjs";
import useRecruiterDetails from "./useRecruiterDetails";
import setWelcomeMessage from "./helpers/setWelcomeMessage";

export default function useAppMessage() {
  const [message, setMessage] = useState(null);
  const { recruiter, isLoading } = useRecruiterDetails();
  const router = useRouter();

  // hide expiry is in the past (client-side only)
  const hideExpiry =
    typeof window === "undefined"
      ? null
      : window.localStorage.getItem("hideWelcomeMessage");
  const hideWelcomeMessage = Boolean(
    hideExpiry && dayjs().isBefore(dayjs(hideExpiry))
  );

  const dismissMessage = () => {
    if (typeof window === "undefined") return;
    // get iso datetime 3 days from now
    const expiry = dayjs().add(3, "day").toISOString();
    window.localStorage.setItem("hideWelcomeMessage", expiry);
    setMessage(null);
  };

  useEffect(() => {
    if (!isLoading && !hideWelcomeMessage && recruiter) {
      setWelcomeMessage(recruiter, setMessage, router);
    }

    // @todo add more messages, as required
  }, [isLoading, router]);

  return { message, dismissMessage };
}
